import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as React from "react";
import { useElementSize } from "../../hooks/useElementSize";

export const InfoPageHero = ({
    title,
    centered
}: {
    title: string;
    centered?: boolean;
}) => {
    const data = useStaticQuery(graphql`
        {
            hero: file(relativePath: { eq: "blog_hero_n.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        layout: FULL_WIDTH
                        quality: 100
                        breakpoints: [2157]
                    )
                }
            }
            heroCentered: file(relativePath: { eq: "blog_centered_hero.jpg" }) {
                childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                }
            }
        }
    `);
    const coverPhoto = getImage(data.hero.childImageSharp.gatsbyImageData);
    const coverPhotoCentered = getImage(
        data.heroCentered.childImageSharp.gatsbyImageData
    );
    const width = useElementSize({});
    const isDesktop = width > 991;
    const useCentered = centered || !isDesktop;
    const photo = useCentered ? coverPhotoCentered : coverPhoto;
    return (
        <div className="relative h-[300px] w-full sm:h-[340px]">
            <div className="absolute h-full w-full overflow-x-hidden">
                <GatsbyImage
                    image={photo}
                    alt={""}
                    objectFit="cover"
                    className="h-full"
                />
            </div>
            <div
                className={`absolute top-2 bottom-2 left-0 right-0 flex w-full flex-col justify-center ${
                    useCentered ? "text-center" : "px-12 xl:px-20"
                }`}
            >
                <h1 className={`text-4xl font-bold tracking-wide text-white`}>
                    {title}
                </h1>
            </div>
        </div>
    );
};
